export const version = "ethers/5.7.1";
//# sourceMappingURL=_version.js.map